export const searchInputHoverStyles = {
  borderWidth: '1px',
  borderColor: 'primary.300',
  borderStyle: 'solid',
  outlineWidth: '4px',
  outlineStyle: 'solid',
  outlineColor: 'primary.50',
  outlineOffset: 0,
};

export const searchInputFocusStyles = {
  borderWidth: '1px',
  borderColor: 'secondary.500',
  borderStyle: 'solid',
  outlineWidth: '4px',
  outlineStyle: 'solid',
  outlineColor: 'secondary.50',
  outlineOffset: 0,
};
